export type DialerRoutingActionType = "transfer_to_number" | "call_profile" | "call_student_relationship"

export type DialerRoutingAction = {
    id?: number
    order: number
    type: DialerRoutingActionType
    phoneNumber?: string
    staffProfileId?: number
    staffProfile?: {
        userId?: number
        profileId: number
        firstName?: string
        lastName?: string
        name?: string
        customProfileId?: string
    }
    studentStaffContactRoleId?: number
    studentStaffContactRole?: {
        id: number
        name: string
    }
}

export type VoicemailVoice = "male" | "female"

export type SmsPhoneNumberDialerSettings = {
    smsPhoneNumbersId: number
    routingActions: DialerRoutingAction[]
    prioritizeRecentStaff: boolean
    voicemailScript: string | null
    voicemailVoice: VoicemailVoice
    voicemailAudioUrl?: string | null
    voicemailPlayUrl?: string | null
    createdAt?: string
    updatedAt?: string
    updatedByProfileId?: number | null
}

export type SmsPhoneNumberDialerDetailResponse = {
    phone: {
        smsPhoneNumbersId: number
        type: "toll_free" | "local"
        areaCode?: number
        phone?: string
        isGlobal?: boolean | number
        campuses?: Array<{id: number; name: string}>
        departments?: Array<{departmentId: number; name: string}>
        user?: {
            id: number
            firstName: string
            middleName?: string | null
            lastName: string
        }
        departmentForDialer?: {departmentId: number; name: string}
        departmentIdForDialer?: number
    }
    settings: SmsPhoneNumberDialerSettings
}

export const NEW_DIALER_ROUTING_ACTION: DialerRoutingAction = {
    order: 0,
    type: "transfer_to_number",
    phoneNumber: ""
}

export const createEmptyDialerSettings = (smsPhoneNumbersId: number): SmsPhoneNumberDialerSettings => ({
    smsPhoneNumbersId,
    routingActions: [],
    prioritizeRecentStaff: true,
    voicemailScript: "",
    voicemailVoice: "female",
    voicemailAudioUrl: null,
    voicemailPlayUrl: null
})
